module.exports = __webpack_public_path__ + "a7799be18d9afb717ce2dbacb07ee915.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/groceries.png
// module id = 3151
// module chunks = 0